import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';
import { BRANDS, nftAvatar } from '../mock';

const NAMES = ['Alex M.', 'Sofia K.', 'Yuki T.', 'Marcus L.', 'Priya S.', 'Diego R.', 'Chen W.', 'Emma H.', 'Omar B.', 'Nina P.', 'Kai N.', 'Lucia F.'];
const COINS = ['BTC', 'ETH', 'USDT', 'SOL', 'BTC ⚡', 'USDC', 'LTC'];
const FLAGS = ['🇺🇸', '🇬🇧', '🇩🇪', '🇯🇵', '🇮🇳', '🇧🇷', '🇫🇷', '🇪🇸', '🇨🇦'];
const AVATAR_STYLES = ['shapes', 'pixel-art', 'bottts-neutral', 'thumbs'];

const genPurchase = () => {
  const brand = BRANDS[Math.floor(Math.random() * BRANDS.length)];
  const denom = brand.denominations[Math.floor(Math.random() * brand.denominations.length)];
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const style = AVATAR_STYLES[Math.floor(Math.random() * AVATAR_STYLES.length)];
  return {
    id: Math.random().toString(36).slice(2),
    name,
    avatar: nftAvatar(name + Math.random().toString(36).slice(2), style),
    brand: brand.name,
    color: brand.color,
    slug: brand.slug,
    amount: denom,
    coin: COINS[Math.floor(Math.random() * COINS.length)],
    flag: FLAGS[Math.floor(Math.random() * FLAGS.length)],
    seconds: Math.floor(Math.random() * 30) + 2,
  };
};

const LivePurchaseTicker = () => {
  const [current, setCurrent] = useState(genPurchase());
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => {
      setCurrent(genPurchase());
      setVisible(true);
      setTimeout(() => setVisible(false), 4500);
    };
    const initial = setTimeout(show, 3500);
    const interval = setInterval(show, 7500);
    return () => { clearTimeout(initial); clearInterval(interval); };
  }, []);

  return (
    <div
      className="fixed left-4 bottom-4 z-40 pointer-events-none"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity .5s ease, transform .5s cubic-bezier(0.22, 1, 0.36, 1)',
      }}
    >
      <div className="bg-white/95 backdrop-blur-md border border-neutral-200 rounded-2xl shadow-xl p-3 pr-4 flex items-center gap-3 max-w-xs">
        <div className="relative shrink-0">
          <div className="w-11 h-11 rounded-xl overflow-hidden ring-2 ring-[#8247E5]/25 shadow-sm">
            <img src={current.avatar} alt={current.name} className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-emerald-500 border-2 border-white flex items-center justify-center">
            <Check className="w-2.5 h-2.5 text-white" strokeWidth={3} />
          </div>
        </div>
        <div className="min-w-0">
          <div className="text-[10px] text-neutral-500">{current.flag} {current.seconds}s ago</div>
          <div className="text-sm text-neutral-900 leading-snug">
            <span className="font-semibold">{current.name}</span> bought <span className="font-semibold">${current.amount} {current.brand}</span>
          </div>
          <div className="text-[10px] text-[#8247E5] font-medium mt-0.5">paid with {current.coin}</div>
        </div>
      </div>
    </div>
  );
};

export default LivePurchaseTicker;
